var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7102 11.7143C17.6172 11.6205 17.5066 11.5461 17.3848 11.4954C17.2629 11.4446 17.1322 11.4185 17.0002 11.4185C16.8682 11.4185 16.7375 11.4446 16.6156 11.4954C16.4937 11.5461 16.3831 11.6205 16.2902 11.7143L13.0002 15.0143V7.42426C13.0002 7.15904 12.8948 6.90469 12.7073 6.71715C12.5198 6.52961 12.2654 6.42426 12.0002 6.42426C11.735 6.42426 11.4806 6.52961 11.2931 6.71715C11.1055 6.90469 11.0002 7.15904 11.0002 7.42426V15.0143L7.71019 11.7143C7.52188 11.526 7.26649 11.4202 7.00019 11.4202C6.73388 11.4202 6.47849 11.526 6.29019 11.7143C6.10188 11.9026 5.99609 12.158 5.99609 12.4243C5.99609 12.6906 6.10188 12.946 6.29019 13.1343L11.2902 18.1343C11.3853 18.2253 11.4974 18.2967 11.6202 18.3443C11.7399 18.3972 11.8693 18.4245 12.0002 18.4245C12.1311 18.4245 12.2605 18.3972 12.3802 18.3443C12.5029 18.2967 12.6151 18.2253 12.7102 18.1343L17.7102 13.1343C17.8039 13.0413 17.8783 12.9307 17.9291 12.8088C17.9798 12.687 18.006 12.5563 18.006 12.4243C18.006 12.2922 17.9798 12.1615 17.9291 12.0397C17.8783 11.9178 17.8039 11.8072 17.7102 11.7143Z",
    fill: "#003A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.b297ab58ddebd348cf3beace86c127fa.svg";
export { ForwardRef as ReactComponent };